import { render, staticRenderFns } from "./germplasmIndex.vue?vue&type=template&id=eff4d138&scoped=true&"
import script from "./germplasmIndex.vue?vue&type=script&lang=js&"
export * from "./germplasmIndex.vue?vue&type=script&lang=js&"
import style0 from "./germplasmIndex.vue?vue&type=style&index=0&id=eff4d138&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff4d138",
  null
  
)

export default component.exports